import { Button} from "@mui/material";
import { styled } from "@actinc/dls/helpers/styled";

export const StyledButton = styled(Button)(({ theme }) => ({
    backgroundColor: theme.palette.primary.dark,
    borderRadius: theme.spacing(1)
}));